import { render, staticRenderFns } from "./ParticipantDiscountInfo.vue?vue&type=template&id=e180b20c&"
import script from "./ParticipantDiscountInfo.vue?vue&type=script&lang=js&"
export * from "./ParticipantDiscountInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantDiscountInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports